var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuporte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 62,
    viewBox: "0 0 56 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x8Dcone Suporte"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.8946 22.9844C39.8946 13.3169 37.6116 5.48145 27.8314 5.48145C18.0511 5.48145 15.6836 12.3586 15.6836 22.9844C15.6836 33.6102 19.4322 40.4874 27.8314 40.4874C36.2305 40.4874 39.8946 32.6519 39.8946 22.9844Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.8101 20.0249C33.3839 20.0249 27.9723 16.0508 25.7175 14.106C24.9565 13.4577 23.9137 13.2886 22.9835 13.7114C21.2924 14.4442 18.5021 15.938 15.8809 18.5874H10.1875",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.6409 27.0712H43.2205C44.3197 27.0712 45.1934 26.1975 45.1934 25.0983V18.3902C44.0096 8.46906 38.6545 1 27.775 1C18.0511 1 11.4558 5.81965 10.1875 18.3902V25.2392C10.1875 26.2539 11.0049 27.0712 12.0195 27.0712H15.8809",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.6973 18.5312H45.2215",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.8379 27.0713V31.3554C12.8379 32.6519 13.9089 33.723 15.2054 33.723H24.5347",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.3965 31.6091H26.5081C25.4185 31.6091 24.5352 32.4925 24.5352 33.5821V33.6103C24.5352 34.6999 25.4185 35.5832 26.5081 35.5832H28.3965C29.4862 35.5832 30.3695 34.6999 30.3695 33.6103V33.5821C30.3695 32.4925 29.4862 31.6091 28.3965 31.6091Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.4411 51.874C27.5504 45.025 20.8423 38.2324 20.8423 38.2324L17.7138 43.5876C17.7138 43.5876 18.6439 45.786 21.9415 51.4512C25.2392 57.1164 27.804 60.8369 27.804 60.8369H1C1 60.8369 2.46563 52.4377 6.80613 48.3791C11.1466 44.3204 14.5289 43.9822 17.742 43.5876",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.252 51.9305C28.1426 45.0815 34.8789 38.2607 34.8789 38.2607L38.0074 43.6159C38.0074 43.6159 37.0773 45.8144 33.7797 51.4796C30.482 57.1448 27.9172 60.8652 27.9172 60.8652H54.7494C54.7494 60.8652 53.2838 52.466 48.9714 48.4074C44.6591 44.3487 41.2487 44.0105 38.0356 43.6159",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M48.9993 55.5099C48.6329 54.0443 47.1109 51.9868 46.209 51.3667",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.3619 49.2811C43.3619 49.2811 43.1646 49.1683 43.0801 49.1401",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuporte);
export default __webpack_public_path__ + "static/media/Suporte.2b60ca5b308adf3e3fce047f4822562f.svg";
export { ForwardRef as ReactComponent };